
<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">ACS Service Center </li>
            </ol>
          </div>
          <h4 class="page-title">Merchant and Terminal prepping</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Merchant and Terminal prepping</h4>
          <p class="sub-header">

          </p>

          <div class="row">
            <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert [dismissible]="false" style="width:100%;">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>
          </div>


          <div class="col-12">

            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
              <thead>
                <tr>
                  <td style="width:25%;">New merchant request</td>
                  <td style="width:25%;">Terminal preparation</td>
                  <td style="width:25%;">Configuration complete</td>
                  <td style="width:25%;">Dispatched</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let n of merchantsSignUpDefault">

                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let merchant of newMerchantsSignUp ">
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Shop Name"></i><b>Shop name:</b><br /> {{ merchant.shopName}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ merchant.merchantNumber}}</b><br />
                        <hr /><!--<b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>Delivery type: {{ merchant.deliveryAddress}}</b><br />-->
                        <p class="card-text">Merchant onboarded by <b>{{merchant.changedBy}}</b> on the <b>{{merchant.changedOn}}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(merchant)" *ngIf="canEditMerchantSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(merchant)}}
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" (click)="viewTerminals(merchant)">
                          <i class="mdi mdi-view-list"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let merchant of MerchantsSignUpOnPrep ">
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Shop Name"></i><b>Shop name:</b><br /> {{ merchant.shopName}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ merchant.merchantNumber}}</b><br />
                        <hr /><!--<b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>Delivery type: {{ merchant.deliveryAddress}}</b><br />-->
                        <p class="card-text">Merchant onboarded by <b>{{merchant.changedBy}}</b> on the <b>{{merchant.changedOn}}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(merchant)" *ngIf="canEditMerchantSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(merchant)}}
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let merchant of ConfigurationComplete">
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Shop Name"></i>Shop name: <br />{{ merchant.shopName}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ merchant.merchantNumber}}</b><br />
                        <hr /><!--<b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>Delivery type: {{ merchant.deliveryAddress}}</b><br />-->
                        <p class="card-text">Merchant onboarded by <b>{{merchant.changedBy}}</b> on the <b>{{merchant.changedOn}}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(merchant)" *ngIf="canEditMerchantSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(merchant)}}
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let merchant of dispatched ">
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Shop Name"></i>Shop name:<br /> {{ merchant.shopName}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ merchant.merchantNumber}}</b><br />
                        <hr /><!--<b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>Delivery type: {{ merchant.deliveryAddress}}</b><br />-->
                        <p class="card-text">Merchant onboarded by <b>{{merchant.changedBy}}</b> on the <b>{{merchant.changedOn}}</b></p>
                        <div class="row">
                          <button type="button" class="btn btn-primary" (click)="editTerminal(merchant)" *ngIf="canEditMerchantSignUp">
                            <i class="mdi mdi-pencil-box-outline"></i>
                            View terminals
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>            


          </div>



        </div>
      </div>
    </div>
  </div>
</div>
